<template>
  <v-flex 
    sm6 
    md6 
    lg6 
    class="text-xs-center">
    <v-card>
      <v-card-text ref="card">
        <!--<div 
          v-show="printer_off" 
          style="width: 100%; height: 100%;">
          <div
            :data-share-badge-id="badge.id" 
            data-iframe-width="auto" 
            data-iframe-height="260"
            data-share-badge-host="https://www.credly.com" />
        </div>-->
        <!-- v-show="!printer_off" -->
        <div 
          id="print-badge">
          <a :href="'https://www.credly.com/badges/' + badge.id + '/public_url'"><v-img
            :data-share-badge-id="badge.id"
            :src="'/images/' + badge.printImage"
            :alt="badge.printName"
            width="100%" />
          </a>
        </div>
        <!--<div
          v-if="printer_off"
          class="badge-name"><span v-html="badge.name" /></div>-->
        <!-- v-if="!printer_off" -->
        <div
          class="badge-name"><span v-html="badge.printName" /></div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<style lang="scss" scoped v-if="false">
</style>

<script type="text/javascript">
export default {
    props: {
        badge: {
          type: Object,
          default: null
        },
        printer_off: {
          type: Boolean,
          default: true
        }
    },
    mounted() {
        (function() {
            /*var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = '//cdn.credly.com/assets/utilities/embed.js';
            var o = document.getElementsByTagName('script')[0];
            o.parentNode.insertBefore(s, o);*/
        })();
    },
}
</script>